(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["versalis-flow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('versalis-flow')) {
    customElements.define('versalis-flow', class VersalisFlow extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-flow-track]');
        this.cards = [...this.querySelectorAll('[data-flow-card]')];
        this.previousButton = this.querySelector('[data-flow-previous]');
        this.nextButton = this.querySelector('[data-flow-next]');
        this.currentLabel = this.querySelector('[data-flow-current]');
        this.activeIndex = 0;
        this.scrollFrame = null;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

        if (!this.track || this.cards.length === 0) return;

        this.querySelectorAll('[data-flow-tab]').forEach((tab) => {
          tab.addEventListener('click', () => this.selectView(tab));
          tab.addEventListener('keydown', (event) => this.handleTabKeydown(event));
        });

        this.previousButton?.addEventListener('click', () => this.goTo(this.activeIndex - 1));
        this.nextButton?.addEventListener('click', () => this.goTo(this.activeIndex + 1));
        this.track.addEventListener('scroll', () => this.queueActiveUpdate(), { passive: true });
        this.track.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.goTo(this.activeIndex - 1);
          }
          if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.goTo(this.activeIndex + 1);
          }
        });

        this.setActive(0);
      }

      disconnectedCallback() {
        if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
      }

      queueActiveUpdate() {
        if (this.scrollFrame) return;
        this.scrollFrame = requestAnimationFrame(() => {
          this.scrollFrame = null;
          const trackCenter = this.track.getBoundingClientRect().left + this.track.clientWidth / 2;
          let closestIndex = 0;
          let closestDistance = Number.POSITIVE_INFINITY;

          this.cards.forEach((card, index) => {
            const bounds = card.getBoundingClientRect();
            const distance = Math.abs(bounds.left + bounds.width / 2 - trackCenter);
            if (distance < closestDistance) {
              closestDistance = distance;
              closestIndex = index;
            }
          });

          this.setActive(closestIndex);
        });
      }

      setActive(index) {
        const boundedIndex = Math.max(0, Math.min(index, this.cards.length - 1));
        this.activeIndex = boundedIndex;
        this.cards.forEach((card, cardIndex) => card.classList.toggle('is-active', cardIndex === boundedIndex));

        const activeCard = this.cards[boundedIndex];
        this.style.setProperty('--vf-active-accent', activeCard.dataset.flowAccent || '#bb7658');
        this.style.setProperty('--vf-progress', String((boundedIndex + 1) / this.cards.length));
        if (this.currentLabel) this.currentLabel.textContent = String(boundedIndex + 1).padStart(2, '0');
        if (this.previousButton) this.previousButton.disabled = boundedIndex === 0;
        if (this.nextButton) this.nextButton.disabled = boundedIndex === this.cards.length - 1;
      }

      goTo(index) {
        const boundedIndex = Math.max(0, Math.min(index, this.cards.length - 1));
        this.cards[boundedIndex].scrollIntoView({
          behavior: this.reducedMotion.matches ? 'auto' : 'smooth',
          block: 'nearest',
          inline: 'center'
        });
        this.setActive(boundedIndex);
      }

      selectView(tab) {
        const card = tab.closest('[data-flow-card]');
        const selectedIndex = tab.dataset.flowView;
        if (!card) return;

        card.querySelectorAll('[data-flow-tab]').forEach((candidate) => {
          const isSelected = candidate === tab;
          candidate.setAttribute('aria-selected', String(isSelected));
          candidate.tabIndex = isSelected ? 0 : -1;
        });

        card.querySelectorAll('[data-flow-panel]').forEach((panel, index) => {
          panel.hidden = String(index) !== selectedIndex;
        });
      }

      handleTabKeydown(event) {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        const tabs = [...event.currentTarget.parentElement.querySelectorAll('[data-flow-tab]')];
        const currentIndex = tabs.indexOf(event.currentTarget);
        let targetIndex = currentIndex;

        if (event.key === 'ArrowLeft') targetIndex = (currentIndex - 1 + tabs.length) % tabs.length;
        if (event.key === 'ArrowRight') targetIndex = (currentIndex + 1) % tabs.length;
        if (event.key === 'Home') targetIndex = 0;
        if (event.key === 'End') targetIndex = tabs.length - 1;

        event.preventDefault();
        event.stopPropagation();
        tabs[targetIndex].focus();
        this.selectView(tabs[targetIndex]);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["versalis-pattern-studio"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('versalis-pattern-studio')) {
    class VersalisPatternStudio extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.epoch = (this.epoch || 0) + 1;
        this.revision = 0;
        this.frame = 0;
        this.exportTimer = 0;
        this.imageCache = new Map();
        this.loaded = false;
        this.near = false;
        this.visible = false;
        this.welcomed = false;
        this.file = null;
        this.objectUrl = null;
        this.pointer = null;
        this.state = this.resumeState ? { ...this.resumeState } : { index: 0, spread: 57, rotation: -22, signature: '' };
        this.canvas = this.querySelector('[data-canvas]');
        this.context = this.canvas.getContext('2d');
        this.stage = this.querySelector('[data-stage]');
        this.status = this.querySelector('[data-status]');
        this.spreadInput = this.querySelector('[data-spread]');
        this.rotationInput = this.querySelector('[data-rotation]');
        this.signatureInput = this.querySelector('[data-signature]');
        this.saveButton = this.querySelector('[data-save]');
        this.shareButton = this.querySelector('[data-share]');
        this.retryButton = this.querySelector('[data-retry]');
        this.copyButton = this.querySelector('[data-copy]');
        this.openLink = this.querySelector('[data-open]');
        this.linkField = this.querySelector('[data-link]');
        this.patterns = [...this.querySelectorAll('[data-pattern]')].map(button => ({ ...button.dataset, button }));
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        if (!this.context || !this.patterns.length) {
          this.say('notSupported');
          this.stage.setAttribute('aria-busy', 'false');
          return;
        }

        this.restoreHash();
        this.drawn = { spread: this.state.spread, rotation: this.state.rotation };
        this.syncControls();
        this.applyPattern();
        this.patterns.forEach((pattern, index) => {
          pattern.button.disabled = false;
          this.listen(pattern.button, 'click', () => this.selectPattern(index));
        });
        this.copyButton.disabled = false;
        this.listen(this.copyButton, 'click', () => this.copyLink());
        this.listen(this.spreadInput, 'input', () => {
          this.state.spread = Number(this.spreadInput.value);
          this.changed();
        });
        this.listen(this.rotationInput, 'input', () => {
          this.state.rotation = Number(this.rotationInput.value);
          this.changed();
        });
        this.listen(this.signatureInput, 'input', () => {
          this.state.signature = this.cleanSignature(this.signatureInput.value);
          this.changed();
        });
        this.listen(this.canvas, 'pointerdown', event => this.pointerDown(event));
        this.listen(this.canvas, 'pointermove', event => this.pointerMove(event));
        this.listen(this.canvas, 'pointerup', event => this.pointerEnd(event));
        this.listen(this.canvas, 'pointercancel', event => this.pointerEnd(event));
        this.listen(this.canvas, 'lostpointercapture', event => this.pointerEnd(event));
        this.listen(this.saveButton, 'click', () => this.save());
        this.listen(this.shareButton, 'click', () => this.share());
        this.listen(this.retryButton, 'click', () => {
          if (this.loaded) this.queueExport(0);
          else this.loadSelected(true);
        });
        this.listen(this.querySelector('[data-make-own]'), 'click', () => this.makeOwn());
        this.listen(window, 'hashchange', () => {
          if (!this.restoreHash()) return;
          this.invalidateExport();
          this.syncControls();
          this.applyPattern();
          this.loadSelected();
        });
        this.listen(this.reducedMotion, 'change', () => this.renderUpdate());
        this.listen(document, 'visibilitychange', () => {
          if (document.hidden) this.stopMotion();
          else if (this.visible) this.renderUpdate();
        });
        this.resizeObserver = new ResizeObserver(() => this.resize());
        this.resizeObserver.observe(this.stage);

        if ('IntersectionObserver' in window) {
          this.preloadObserver = new IntersectionObserver(entries => {
            if (!entries.some(entry => entry.isIntersecting)) return;
            this.near = true;
            this.loadSelected();
            this.preloadObserver.disconnect();
          }, { rootMargin: '350px 0px' });
          this.preloadObserver.observe(this);
          this.visibilityObserver = new IntersectionObserver(entries => {
            this.visible = entries.some(entry => entry.isIntersecting);
            if (this.visible) {
              if (this.loaded) this.welcome();
            } else this.stopMotion();
          }, { threshold: .12 });
          this.visibilityObserver.observe(this.stage);
        } else {
          this.near = true;
          this.visible = true;
          this.loadSelected();
        }
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.epoch = (this.epoch || 0) + 1;
        this.revision = (this.revision || 0) + 1;
        this.resizeObserver?.disconnect();
        this.preloadObserver?.disconnect();
        this.visibilityObserver?.disconnect();
        cancelAnimationFrame(this.frame);
        clearTimeout(this.exportTimer);
        if (this.objectUrl) URL.revokeObjectURL(this.objectUrl);
        this.objectUrl = null;
        this.file = null;
        this.pointer = null;
      }

      listen(target, type, callback) {
        target.addEventListener(type, callback, { signal: this.controller.signal });
      }

      say(key) {
        this.status.textContent = this.dataset[`msg${key[0].toUpperCase()}${key.slice(1)}`] || '';
      }

      cleanSignature(value) {
        return Array.from(String(value).normalize('NFC').replace(/[\u0000-\u001f\u007f-\u009f\u202a-\u202e\u2066-\u2069]/g, '')).slice(0, 22).join('').trim();
      }

      clamp(value, minimum, maximum, fallback) {
        const number = Number(value);
        return value !== null && value !== '' && Number.isFinite(number) ? Math.round(Math.min(maximum, Math.max(minimum, number))) : fallback;
      }

      restoreHash() {
        const hash = window.location.hash;
        if (!hash.startsWith('#desen-atolyesi?') || hash.length > 1500) return false;
        const params = new URLSearchParams(hash.slice('#desen-atolyesi?'.length));
        const index = this.patterns.findIndex(pattern => pattern.key === params.get('p'));
        if (index < 0) return false;
        this.state = {
          index,
          spread: this.clamp(params.get('s'), 0, 100, 57),
          rotation: this.clamp(params.get('r'), -180, 180, -22),
          signature: this.cleanSignature(params.get('n') || '')
        };
        this.restored = true;
        this.querySelector('[data-recipient]').hidden = false;
        return true;
      }

      shareUrl() {
        const url = new URL(this.dataset.rootUrl, window.location.origin);
        url.search = '';
        const params = new URLSearchParams({ p: this.patterns[this.state.index].key, s: String(this.state.spread), r: String(this.state.rotation) });
        if (this.state.signature) params.set('n', this.state.signature);
        url.hash = `desen-atolyesi?${params.toString()}`;
        return url.href;
      }

      makeOwn() {
        this.state.signature = '';
        this.querySelector('[data-recipient]').hidden = true;
        if (window.location.hash.startsWith('#desen-atolyesi?')) {
          window.history.replaceState(window.history.state, '', `${window.location.pathname}${window.location.search}#desen-atolyesi`);
        }
        this.syncControls();
        this.changed();
        this.spreadInput.focus({ preventScroll: true });
      }

      syncControls() {
        this.spreadInput.value = this.state.spread;
        this.rotationInput.value = this.state.rotation;
        this.rotationInput.setAttribute('aria-valuetext', `${this.state.rotation}°`);
        this.signatureInput.value = this.state.signature;
      }

      applyPattern() {
        const pattern = this.patterns[this.state.index];
        this.patterns.forEach((item, index) => item.button.setAttribute('aria-pressed', String(index === this.state.index)));
        this.style.setProperty('--vps-paper', pattern.paper);
        this.style.setProperty('--vps-ink', pattern.ink);
        this.style.setProperty('--vps-accent', pattern.accent);
        this.querySelector('[data-pattern-label]').textContent = pattern.label;
        this.querySelector('[data-product] [data-product-title]').textContent = pattern.productTitle;
        this.querySelector('[data-product]').href = pattern.productUrl;
        this.querySelector('[data-original]').src = pattern.image;
        this.querySelector('[data-original]').alt = pattern.productTitle;
      }

      selectPattern(index) {
        if (index === this.state.index && this.loaded) return;
        this.state.index = index;
        this.invalidateExport();
        this.applyPattern();
        this.near = true;
        this.loadSelected();
      }

      async loadSelected(retry = false) {
        if (!this.near) return;
        const epoch = this.epoch;
        const index = this.state.index;
        const pattern = this.patterns[index];
        this.loaded = false;
        this.removeAttribute('data-ready');
        this.stage.setAttribute('aria-busy', 'true');
        this.retryButton.hidden = true;
        this.say('loading');
        [this.spreadInput, this.rotationInput, this.signatureInput].forEach(input => { input.disabled = true; });
        if (retry) this.imageCache.delete(pattern.key);
        if (!this.imageCache.has(pattern.key)) {
          const promise = new Promise((resolve, reject) => {
            const image = new Image();
            image.crossOrigin = 'anonymous';
            image.decoding = 'async';
            image.onload = () => image.naturalWidth ? resolve(image) : reject(new Error('Empty image'));
            image.onerror = () => reject(new Error('Image unavailable'));
            image.src = pattern.image;
          });
          this.imageCache.set(pattern.key, promise);
        }
        try {
          const image = await this.imageCache.get(pattern.key);
          if (!this.isConnected || this.epoch !== epoch || this.state.index !== index) return;
          this.image = image;
          this.loaded = true;
          this.setAttribute('data-ready', '');
          this.stage.setAttribute('aria-busy', 'false');
          [this.spreadInput, this.rotationInput, this.signatureInput].forEach(input => { input.disabled = false; });
          this.resize();
          if (this.visible) this.welcome();
          this.queueExport(100);
        } catch {
          if (!this.isConnected || this.epoch !== epoch || this.state.index !== index) return;
          this.stage.setAttribute('aria-busy', 'false');
          this.retryButton.hidden = false;
          this.say('loadError');
        }
      }

      changed() {
        this.welcomed = true;
        this.spreadInput.value = this.state.spread;
        this.rotationInput.value = this.state.rotation;
        this.rotationInput.setAttribute('aria-valuetext', `${this.state.rotation}°`);
        this.invalidateExport();
        this.renderUpdate();
        this.queueExport(350);
      }

      invalidateExport() {
        this.revision += 1;
        clearTimeout(this.exportTimer);
        this.file = null;
        this.saveButton.disabled = true;
        this.shareButton.disabled = true;
        this.retryButton.hidden = true;
        this.openLink.hidden = true;
        this.openLink.removeAttribute('href');
        this.querySelector('[data-link-fallback]').hidden = true;
        if (this.objectUrl) URL.revokeObjectURL(this.objectUrl);
        this.objectUrl = null;
      }

      queueExport(delay) {
        clearTimeout(this.exportTimer);
        if (!this.loaded) return;
        this.say('preparing');
        this.exportTimer = setTimeout(() => this.prepareExport(), delay);
      }

      async prepareExport() {
        if (!this.loaded || !this.isConnected) return;
        const revision = this.revision;
        const epoch = this.epoch;
        const output = document.createElement('canvas');
        output.width = 1080;
        output.height = 1920;
        try {
          const context = output.getContext('2d');
          if (!context) throw new Error('Canvas unavailable');
          this.artwork(context, output.width, output.height, this.state, true);
          const blob = await new Promise((resolve, reject) => {
            output.toBlob(value => value ? resolve(value) : reject(new Error('PNG unavailable')), 'image/png');
          });
          if (!this.isConnected || this.epoch !== epoch || this.revision !== revision) return;
          if (this.objectUrl) URL.revokeObjectURL(this.objectUrl);
          this.objectUrl = URL.createObjectURL(blob);
          this.file = new File([blob], `versalis-desen-${this.patterns[this.state.index].key}.png`, { type: 'image/png' });
          this.openLink.href = this.objectUrl;
          this.saveButton.disabled = false;
          this.shareButton.disabled = false;
          this.retryButton.hidden = true;
          this.say('ready');
        } catch {
          if (!this.isConnected || this.epoch !== epoch || this.revision !== revision) return;
          this.retryButton.hidden = false;
          this.say('exportError');
        } finally {
          output.width = 1;
          output.height = 1;
        }
      }

      save() {
        if (!this.objectUrl || !this.file) return;
        const link = document.createElement('a');
        link.href = this.objectUrl;
        link.download = this.file.name;
        link.hidden = true;
        this.append(link);
        link.click();
        link.remove();
        this.openLink.hidden = false;
        this.say('downloadStarted');
      }

      share() {
        if (!this.file) return;
        if (typeof navigator.share !== 'function') {
          this.copyLink();
          return;
        }
        const url = this.shareUrl();
        const title = this.dataset.title;
        const text = this.dataset.msgShareText;
        let payload = { title, text, url };
        try {
          if (typeof navigator.canShare === 'function' && navigator.canShare({ files: [this.file] })) {
            payload = { files: [this.file], title, text: `${text}\n${url}` };
          }
          navigator.share(payload).then(() => {
            if (this.isConnected) this.say('ready');
          }).catch(error => {
            if (!this.isConnected) return;
            if (error.name === 'AbortError') this.say('ready');
            else {
              this.showLink();
              this.say('shareError');
            }
          });
        } catch {
          this.showLink();
          this.say('shareError');
        }
      }

      showLink(select = false) {
        this.querySelector('[data-link-fallback]').hidden = false;
        this.linkField.value = this.shareUrl();
        if (select) {
          this.linkField.focus({ preventScroll: true });
          this.linkField.select();
        }
      }

      copyLink() {
        this.showLink();
        if (!navigator.clipboard?.writeText) {
          this.showLink(true);
          this.say('copyFallback');
          return;
        }
        navigator.clipboard.writeText(this.linkField.value).then(() => {
          if (this.isConnected) this.say('copied');
        }).catch(() => {
          if (!this.isConnected) return;
          this.showLink(true);
          this.say('copyFallback');
        });
      }

      pointerDown(event) {
        if (!this.loaded || !event.isPrimary || event.button !== 0) return;
        this.welcomed = true;
        this.pointer = { id: event.pointerId, x: event.clientX, y: event.clientY, rotation: this.state.rotation, spread: this.state.spread, dragging: false };
      }

      pointerMove(event) {
        if (!this.pointer || this.pointer.id !== event.pointerId) return;
        const dx = event.clientX - this.pointer.x;
        const dy = event.clientY - this.pointer.y;
        if (!this.pointer.dragging) {
          if (Math.abs(dy) > Math.abs(dx) && Math.abs(dy) > 8) {
            this.pointer = null;
            return;
          }
          if (Math.abs(dx) < 7) return;
          this.pointer.dragging = true;
          this.canvas.setPointerCapture(event.pointerId);
        }
        const ratio = dx / Math.max(this.stage.clientWidth, 1);
        this.state.rotation = Math.round(((this.pointer.rotation + ratio * 280 + 540) % 360 + 360) % 360 - 180);
        this.state.spread = Math.round(Math.max(0, Math.min(100, this.pointer.spread + ratio * 75)));
        this.changed();
      }

      pointerEnd(event) {
        if (!this.pointer || this.pointer.id !== event.pointerId) return;
        this.pointer = null;
        if (this.canvas.hasPointerCapture(event.pointerId)) this.canvas.releasePointerCapture(event.pointerId);
        if (this.loaded) this.queueExport(100);
      }

      resize() {
        const width = this.stage.clientWidth;
        const height = this.stage.clientHeight;
        if (!width || !height) return;
        const ratio = Math.min(window.devicePixelRatio || 1, 2);
        this.canvas.width = Math.round(width * ratio);
        this.canvas.height = Math.round(height * ratio);
        this.paint();
      }

      welcome() {
        if (this.welcomed || !this.loaded) return;
        this.welcomed = true;
        if (!this.restored && !this.reducedMotion.matches && !document.hidden) {
          this.drawn = { spread: Math.max(0, this.state.spread - 24), rotation: this.state.rotation - 18 };
        }
        this.renderUpdate();
      }

      stopMotion() {
        cancelAnimationFrame(this.frame);
        this.frame = 0;
        this.drawn = { spread: this.state.spread, rotation: this.state.rotation };
        this.paint();
      }

      renderUpdate() {
        if (!this.loaded) return;
        if (this.reducedMotion.matches || !this.visible || document.hidden) {
          this.stopMotion();
          return;
        }
        if (this.frame) return;
        let previous = performance.now();
        let start = previous;
        const animate = now => {
          this.frame = 0;
          if (!this.isConnected || !this.loaded) return;
          const factor = 1 - Math.exp(-Math.min(now - previous, 60) / 82);
          previous = now;
          let angle = this.state.rotation - this.drawn.rotation;
          if (angle > 180) angle -= 360;
          if (angle < -180) angle += 360;
          this.drawn.spread += (this.state.spread - this.drawn.spread) * factor;
          this.drawn.rotation += angle * factor;
          this.paint();
          if (now - start < 950 && Math.abs(this.state.spread - this.drawn.spread) + Math.abs(angle) > .08) {
            this.frame = requestAnimationFrame(animate);
          } else this.stopMotion();
        };
        this.frame = requestAnimationFrame(animate);
      }

      paint() {
        if (!this.context || !this.canvas.width) return;
        this.artwork(this.context, this.canvas.width, this.canvas.height, this.drawn || this.state, false);
      }

      petal(context, length, width, bend) {
        context.beginPath();
        context.moveTo(0, 0);
        context.bezierCurveTo(width * .62, -length * .2, width + bend, -length * .72, bend, -length);
        context.bezierCurveTo(-width + bend, -length * .76, -width * .55, -length * .16, 0, 0);
        context.closePath();
      }

      artwork(context, width, height, movement, exporting) {
        const pattern = this.patterns[this.state.index];
        context.clearRect(0, 0, width, height);
        context.fillStyle = pattern.paper;
        context.fillRect(0, 0, width, height);
        if (!this.loaded || !this.image?.naturalWidth) return;
        const texture = this.image;
        const scale = Math.min(width * .96, height * (exporting ? .58 : .93));
        const spread = movement.spread / 100;
        const turn = movement.rotation * Math.PI / 180;
        context.save();
        context.translate(width * .5, height * (exporting ? .54 : .5));
        for (let ring = 0; ring < 2; ring += 1) {
          for (let index = 0; index < 11; index += 1) {
            const angle = index / 11 * Math.PI * 2 + turn + ring * .31;
            const length = scale * (ring === 0 ? .42 : .295) * (.87 + .13 * Math.sin(index * 1.9 + spread * 3));
            const breadth = scale * (.062 + spread * .052) * (ring === 0 ? 1 : .84);
            const bend = scale * (.035 + (1 - spread) * .175);
            context.save();
            context.rotate(angle);
            context.translate(0, -scale * (.017 + spread * .04));
            context.rotate((1 - spread) * .7);
            this.petal(context, length, breadth, bend);
            context.shadowColor = '#20170e28';
            context.shadowBlur = scale * .013;
            context.shadowOffsetY = scale * .005;
            context.fillStyle = pattern.accent;
            context.fill();
            context.shadowBlur = 0;
            context.shadowOffsetY = 0;
            context.clip();
            const sx = texture.naturalWidth * (.2 + index % 3 * .045);
            const sy = texture.naturalHeight * (.12 + index % 4 * .09);
            const sw = texture.naturalWidth * .47;
            const sh = texture.naturalHeight * .4;
            context.drawImage(texture, sx, sy, sw, sh, -breadth * 2, -length, breadth * 4 + bend, length * 1.05);
            const sheen = context.createLinearGradient(-breadth, -length * .4, breadth + bend, -length * .7);
            sheen.addColorStop(0, '#ffffff45');
            sheen.addColorStop(.33, '#ffffff00');
            sheen.addColorStop(.65, ring === 0 ? '#291e1519' : '#291e1530');
            sheen.addColorStop(1, '#ffffff32');
            context.fillStyle = sheen;
            context.fillRect(-breadth * 2, -length, breadth * 4 + bend, length * 1.1);
            context.restore();
            context.save();
            context.rotate(angle);
            context.translate(0, -scale * (.017 + spread * .04));
            context.rotate((1 - spread) * .7);
            this.petal(context, length, breadth, bend);
            context.strokeStyle = pattern.paper;
            context.lineWidth = Math.max(1, scale * .0022);
            context.globalAlpha = .72;
            context.stroke();
            context.restore();
          }
        }
        context.beginPath();
        context.arc(0, 0, scale * .026, 0, Math.PI * 2);
        context.fillStyle = pattern.paper;
        context.fill();
        context.restore();
        context.fillStyle = pattern.ink;
        context.textAlign = 'center';
        if (this.state.signature) {
          context.font = `italic ${Math.max(17, width * .046)}px Georgia, serif`;
          context.fillText(this.state.signature, width * .5, height * (exporting ? .81 : .875), width * .78);
        }
        if (exporting) {
          context.globalAlpha = .8;
          context.font = `${width * .027}px Georgia, serif`;
          context.fillText(this.dataset.brand, width * .5, height * .928, width * .6);
          context.globalAlpha = 1;
        }
      }
    }
    customElements.define('versalis-pattern-studio', VersalisPatternStudio);
  }

  if (!customElements.get('versalis-pattern-door')) {
    class VersalisPatternDoor extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.dialog = this.querySelector('[data-studio-dialog]');
        this.mount = this.querySelector('[data-studio-mount]');
        this.template = this.querySelector('[data-studio-template]');
        if (!this.dialog || !this.mount || !this.template || typeof this.dialog.showModal !== 'function') return;
        this.controller = new AbortController();
        this.historyKey = '__versalisPatternDialog';
        this.historyToken = `${Date.now()}-${Math.random().toString(36).slice(2)}`;
        this.setAttribute('data-dialog-ready', '');
        this.listen(document, 'click', event => {
          if (!(event.target instanceof Element) || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          const trigger = event.target.closest('a.vps-secret-trigger');
          if (!trigger) return;
          const url = new URL(trigger.href, window.location.href);
          if (url.origin !== window.location.origin || url.pathname !== window.location.pathname || !this.isStudioHash(url.hash)) return;
          event.preventDefault();
          if (this.dialog.open || this.awaitingBack) return;
          this.returnFocus = trigger;
          if (!this.isStudioHash(window.location.hash)) {
            const state = window.history.state && typeof window.history.state === 'object' ? window.history.state : {};
            window.history.pushState({ ...state, [this.historyKey]: this.historyToken }, '', `${window.location.pathname}${window.location.search}${url.hash}`);
          }
          this.open();
        });
        this.listen(this.querySelector('[data-dialog-close]'), 'click', () => this.dismiss());
        this.listen(this.dialog, 'cancel', event => {
          event.preventDefault();
          this.dismiss();
        });
        this.listen(this.dialog, 'pointerdown', event => {
          this.backdropPointer = event.target === this.dialog && this.outsideDialog(event) ? event.pointerId : null;
        });
        this.listen(this.dialog, 'pointerup', event => {
          if (event.pointerId === this.backdropPointer && event.target === this.dialog && this.outsideDialog(event)) this.dismiss();
          this.backdropPointer = null;
        });
        this.listen(this.dialog, 'pointercancel', () => { this.backdropPointer = null; });
        this.listen(this.dialog, 'close', () => {
          if (this.dialog.open) return;
          if (this.mount.childElementCount || this.scrollState) {
            this.cleanupView();
            this.clearStudioHash();
          }
        });
        this.listen(window, 'hashchange', () => this.syncHash());
        this.listen(window, 'popstate', () => {
          this.awaitingBack = false;
          this.syncHash();
        });
        this.listen(window, 'pagehide', () => this.closeView(false));
        this.listen(window, 'pageshow', () => this.syncHash());
        this.syncHash();
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.closeView(false);
        this.removeAttribute('data-dialog-ready');
      }

      listen(target, type, callback) {
        target.addEventListener(type, callback, { signal: this.controller.signal });
      }

      isStudioHash(hash) {
        return hash === '#desen-atolyesi' || hash.startsWith('#desen-atolyesi?');
      }

      outsideDialog(event) {
        const bounds = this.dialog.getBoundingClientRect();
        return event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom;
      }

      syncHash() {
        if (this.isStudioHash(window.location.hash)) this.open();
        else this.closeView();
      }

      open() {
        if (!this.isConnected || this.dialog.open) return;
        if (!this.returnFocus?.isConnected) {
          const active = document.activeElement;
          this.returnFocus = active instanceof HTMLElement && active !== document.body ? active : document.querySelector('.vps-secret-trigger');
        }
        const fragment = this.template.content.cloneNode(true);
        const studio = fragment.querySelector('versalis-pattern-studio');
        if (studio && this.savedState) studio.resumeState = { ...this.savedState };
        this.mount.append(fragment);
        try {
          this.dialog.showModal();
        } catch {
          this.mount.replaceChildren();
          this.removeAttribute('data-dialog-ready');
          return;
        }
        this.lockScroll();
        this.dialog.scrollTop = 0;
        this.querySelector('[data-dialog-close]').focus({ preventScroll: true });
      }

      dismiss() {
        if (!this.dialog.open) return;
        const ownsEntry = this.isStudioHash(window.location.hash) && window.history.state?.[this.historyKey] === this.historyToken;
        this.closeView();
        if (ownsEntry) {
          this.awaitingBack = true;
          window.history.back();
        } else this.clearStudioHash();
      }

      clearStudioHash() {
        if (!this.isStudioHash(window.location.hash)) return;
        window.history.replaceState(window.history.state, '', `${window.location.pathname}${window.location.search}`);
      }

      closeView(returnFocus = true) {
        if (this.dialog?.open) this.dialog.close();
        this.cleanupView(returnFocus);
      }

      cleanupView(returnFocus = true) {
        const studio = this.mount?.querySelector('versalis-pattern-studio');
        const wasOpen = Boolean(studio || this.scrollState);
        if (studio?.state) this.savedState = { ...studio.state };
        this.mount?.replaceChildren();
        this.unlockScroll();
        this.backdropPointer = null;
        if (wasOpen && returnFocus && this.returnFocus?.isConnected) this.returnFocus.focus({ preventScroll: true });
        this.returnFocus = null;
      }

      lockScroll() {
        if (this.scrollState) return;
        const body = document.body;
        const html = document.documentElement;
        const properties = ['position', 'top', 'left', 'right', 'width', 'overflow', 'padding-right'];
        const scrollbar = Math.max(0, window.innerWidth - html.clientWidth);
        this.scrollState = {
          x: window.scrollX,
          y: window.scrollY,
          body: properties.map(property => [property, body.style.getPropertyValue(property), body.style.getPropertyPriority(property)]),
          html: ['overflow', 'scroll-behavior'].map(property => [property, html.style.getPropertyValue(property), html.style.getPropertyPriority(property)])
        };
        const padding = Number.parseFloat(window.getComputedStyle(body).paddingRight) || 0;
        html.style.setProperty('overflow', 'hidden');
        html.style.setProperty('scroll-behavior', 'auto');
        body.style.setProperty('position', 'fixed');
        body.style.setProperty('top', `${-this.scrollState.y}px`);
        body.style.setProperty('left', `${-this.scrollState.x}px`);
        body.style.setProperty('right', '0');
        body.style.setProperty('width', '100%');
        body.style.setProperty('overflow', 'hidden');
        if (scrollbar) body.style.setProperty('padding-right', `${padding + scrollbar}px`);
      }

      unlockScroll() {
        if (!this.scrollState) return;
        const saved = this.scrollState;
        this.scrollState = null;
        const restore = (style, entries) => entries.forEach(([property, value, priority]) => {
          if (value) style.setProperty(property, value, priority);
          else style.removeProperty(property);
        });
        restore(document.body.style, saved.body);
        const overflow = saved.html.filter(([property]) => property === 'overflow');
        restore(document.documentElement.style, overflow);
        window.scrollTo(saved.x, saved.y);
        restore(document.documentElement.style, saved.html.filter(([property]) => property === 'scroll-behavior'));
      }
    }
    customElements.define('versalis-pattern-door', VersalisPatternDoor);
  }

  } catch(e) { console.error(e); }
})();
})();
